module.exports = __webpack_public_path__ + "img/wosstwo.0f21a945.png";